import UAParser from 'ua-parser-js';

interface GetUserAgentResponse {
  name?: string;
  major?: string;
  minor?: string;
}
export const getUserAgent = (): GetUserAgentResponse | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const parser = new UAParser();

  const {
    browser: { name, version },
  } = parser.getResult();

  const [major, minor] = version?.split('.') ?? [];

  return {
    name,
    major,
    minor,
  };
};

export default getUserAgent;
